import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBubbleComponent } from './info-bubble.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [InfoBubbleComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
  ],
  exports: [InfoBubbleComponent]
})
export class InfoBubbleModule { }
